package com.klantenstop.web.data.models.dto.requests.categories

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class UpdateCategory(
    val name: String? = null,
    @SerialName("alt_text")
    val altText: String? = null,
    val highlighted: Boolean? = null,
    val description: String? = null,
    val deleteImage: Boolean = false
) {
    // With the update, both the name and the altText can be null, depending on which the user wants to update.
    val isValid get() = name.isNullOrBlank().not() || altText != null || highlighted != null || description != null || deleteImage

}
